"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.accountsPlan", ["nucont.shared"]);
require("./accounts-plan.routes");
